/**
 *  // Extending CT.utils, jQuery and/or Underscore namespaces here for FLIGHTS only
 */
!function(module){
    //>>excludeStart("requireTmpl", pragmas.requireTmpl);
    if(window.define) define('flights/flight_utils',['ct_utils'], module)
    else
    //>>excludeEnd("requireTmpl");
        module()
}(function(){

    $.extend(true, CT.utils, {
        helperFunctions : {

            /**
             * @desc
             * Any changes made here are to be moved to filtersAndSortersWorker.js commonFilterSorter>>getFlightFare.
             *
             */
            getAirJsonUrl : function(paramsHash){
                var url = CT.settings[CT.app].urls.domesticSearch;
                if(paramsHash.multicity){
                    url = CT.settings[CT.app].urls.multiCitySearch
                }else if(paramsHash.intl=='y'){
                    url = CT.settings[CT.app].urls.intlSearch
                }
                return url;
            },
            isFlNumCombinable : function(otherCarrierNames,cc,carrierNames){
                if(!this.isAirlineCombinable([otherCarrierNames,carrierNames]))
                    return false;

                if(cc){
                    if(typeof cc == 'string')
                        cc = _.uniq(cc.split(','));
                }else cc = [];
                var flightCode = this.getflightCodes(otherCarrierNames);

                if(_.contains(cc,flightCode))
                    return true;
                return false;
            },
            getflightCodes : function(carrierNames){
                if(typeof carrierNames == 'string')
                    carrierNames = carrierNames.split(',');

                carrierNames = _.uniq(carrierNames);
                return _.map(carrierNames,function(al){
                    al = al.split('-');
                    return al[al.length - 1];
                }).join('$');
            },
            isAirlineCombinable: function(carrierNamesArr){
                var arr = [];
                _.map(carrierNamesArr,function(carrier){
                    if(typeof carrier == 'string')
                        carrier = carrier.split(',');
                    _.extend(arr,(_.map(carrier,function(c){return c.split('-')[0]})));
                });
                return _.uniq(arr).length == 1;
            },
            getFlightFare : function(fare, sectorIndex, withFlags){
                var tabCache = CT.cache[CT.settings.currentTab]
                var flags  = _.extend({}, tabCache.flags, withFlags);
                var searchType = tabCache.searchType;
                var jsonVer =  CT.masterJson && CT.masterJson.get() && CT.masterJson.get().jsons.jsonVer ? CT.masterJson.get().jsons.jsonVer : CT.settings[CT.app].responseVer;
                var newFare = null;

                if(typeof fare === "undefined") return newFare

                if(flags.isCorpFare){
                    if( fare.CORP) {
                        fare = fare.CORP;
                    } else {
                        newFare = null;
                    }
                }

                if(flags.isSPLRT || (fare.SPLRT && !fare.dfd && !flags.forceNormalFare)){
                    if(fare.SPLRT){
                        if(jsonVer == 'V3'){
                            var forceDfd = flags.isRefundable == 1 && !(flags.isTabClicked || flags.singleAirlineFilter) ? 'R' : false;

                            if(withFlags.otherCarrierNames){
                                var f = _.find(fare.SPLRT,function(f){
                                    var cc = f[f.dfd].cc && f[f.dfd].cc.split(',');
                                    if(CT.utils.helperFunctions.isFlNumCombinable(withFlags.otherCarrierNames,cc,withFlags.carrierNames))
                                        if(flags.isRefundable && !flags.isTabClicked)
                                            return f.dfd == 'R' ? f : null;
                                        else
                                            return f;
                                });
                                newFare = f && f[forceDfd || f.dfd];
                            }else { //Return the cheapest fare, only for sorting purpose.
                                if(fare.SelectedSPLRT || withFlags.getSelected)
                                    f = fare.SelectedSPLRT;
                                else
                                    f = fare.SPLRT[0];

                                if(flags.isRefundable && !flags.isTabClicked){ // if specialRT tabs are clicked only show the dfd fare
                                    if(fare.SelectedSPLRT || withFlags.getSelected)
                                        f = fare.SelectedSPLRT && fare.SelectedSPLRT.R ? fare.SelectedSPLRT : null;
                                    else
                                        f = _.find(fare.SPLRT,function(f){ return f.dfd == 'R'  });
                                }
                                newFare = f && f[forceDfd || f.dfd];
                            }

                        }else{
                            newFare = fare.SPLRT[fare.SPLRT.dfd];
                            if(flags.isRefundable && !flags.isTabClicked){ // if specialRT tabs are clicked only show the dfd fare
                                newFare = fare.SPLRT.R
                            }
                        }

                    } else { // this code is for spicejet and indigo where we are showing normal and special fare both
                        newFare = (fare.dfd)?fare[fare.dfd]:null;
                        if(flags.isRefundable && !flags.isTabClicked){
                            newFare = fare.R
                        }
                    }
                }else{
                    newFare = (fare.dfd)?fare[fare.dfd]:(fare.CORP && fare.CORP.dfd ? fare.CORP[fare.CORP.dfd] : null);
                    if(searchType.multiCity && !searchType.isIntl
                        && flags.sectors[sectorIndex] && flags.sectors[sectorIndex].isRefundable){
                        newFare = fare.R
                    }else if(flags.isRefundable && !flags.isTabClicked){
                        newFare = fare.R ? fare.R : (fare.CORP ? fare.CORP.R : null);
                    }

                }
                return newFare; // newFare can be null
            },
            getDisplayPrice: function(price){
                try{
                    var secondaryJson = CT.masterJson.get().jsons;

                    if(secondaryJson.walletAmt){
                        var balancePrice = (price - secondaryJson.walletAmt);
                        return balancePrice > 0 ? balancePrice : 0;
                    }
                }catch(e){
                    L(e);
                }
                return price;
            },
            getBundledFareInfo:function(opts){
                var ret = {price:{}, categories:[], enabled:false,inclusions:[],priceEnabled:false};
                if(opts.al && opts.mJson &&  opts.mJson.jsons.bundledfares){
                    ret.enabled = true;
                    ret.categories = opts.mJson.jsons.bundledfares;
                }
                if(opts.priceObj){
                    ret.price = {total: opts.priceObj.pr, extra:0};
                    if(opts.selectedBundleCategory && opts.priceObj.bfc && opts.priceObj.bfc[opts.selectedBundleCategory.toLowerCase()+'pr'] != undefined){
                        ret.price.extra = parseInt(opts.priceObj.bfc[opts.selectedBundleCategory.toLowerCase()+'pr']);
                        ret.priceEnabled = true;
                        ret.enabled = true;
                    }

                    ret.price.total+=ret.price.extra;
                    ret.price.totalFormatted = CT.utils.formatForCurrency(Number(ret.price.total), false, null, false);
                    ret.price.extraFormatted = CT.utils.formatForCurrency(Number(ret.price.extra), false, null, false);
                }

                return ret;

            },
            getSEMParams : function(params , outputObject){
                outputObject = outputObject || {};
                params = (typeof params == "string")? _.deserialize(params) : params;

                return outputObject;

				/*return $.extend(outputObject ,
				 _.pick(params ,
				 _.filter(_.keys(params), function(param){
				 //return /^gclid$|^utm_/.test(param);
				 return /^utm_/.test(param);
				 })));*/

            },
            ifNull: function(value,replaceWith){//needs to move to lodash or common utility function
                if(!value)
                    return replaceWith;
                return value;
            },
            /**
             * This converts a overflow  horizontal div to a scrollable div with next and prev scroll bars.
             *
             */
            createSlideView : function ($node /*legsContainer*/, columnWidth, columnsPerPage, totalColumns, $linksContainer){

                var navLinkTmp = '<div class="disclosureFade {{divCls}}" style="display:none;"><a class="{{linkCls}}" href="javascript:void(0);"></a></div>'
                var $links = {prev:{},next:{}};
                var shiftValue = totalColumns - columnsPerPage;
                var slideOffset = (totalColumns == 4)?50:285;
                $linksContainer = ($linksContainer || $node);

                function createNavLinks(){
                    _.each([{"linkCls":"scrollLeft", "divCls":"left", "name":"prev"},
                        {"linkCls":"scrollRight", "divCls":"right", "name":"next"}],function(linkData){
                        $linksContainer.append($links[linkData.name] = $(CT.to_html(navLinkTmp, linkData)));
                    });
                }

                function slide(direction,amount){
                    var existingLeftValue = parseInt($node.css("left").replace("px",""),10);
                    if(direction  == "left"){
                        amount = -(columnWidth * amount) + slideOffset;
                    }else{
                        amount = (columnWidth * amount) - slideOffset;
                    }
                    amount = existingLeftValue + amount;
                    $node.css("left",(amount+"px"));
                }

                function init(){
                    createNavLinks();
                    $links.next.show();
                    $node.css("left","0px");
                    $links.next.on('click',function(){
                        slide("left",shiftValue);
                        $links.next.hide();
                        $links.prev.show();
                    });
                    $links.prev.on('click',function(){
                        slide("right",shiftValue);
                        $links.next.show();
                        $links.prev.hide();
                    });
                }
                init();
            },

            /**
             Wrapper for Segregating GA filter/Sort tracking on SRP for Intl/Dom and OW/RT
             */
            trackFlightGAEvent : function(category,action,label,timeout){
                return function(){
                    var searchType = CT.cache[CT.settings.currentTab].searchType;
                    var newLabel  = label + "_" + ((searchType.isIntl)?"Intl":"Dom") + "_" + ((searchType.multiCity || searchType.roundTrip)?((searchType.roundTrip)?"RT":"MC"):"OW");
                    CT.utils.helperFunctions.trackGAEvent(category,action,newLabel,timeout);
                }
            },getMr : function(fareObj,mJson,flags){ //Format like MiniRule Ajax Response JSON
                var mr = {};
                var jsonMr = fareObj.mr;
                mr.MR = 'Y',mr.ADT = {
                    AD:{},ADNS:{},BD:{A:jsonMr.A,C:jsonMr.C},BDNS:{}
                },mr.Refund = (flags.isRefundable || fareObj.ft === "R" ? "Y": "N"),
                    mr.oca = jsonMr.oca,
                    mr.occ = jsonMr.occ,
                    mr.cta=jsonMr.cta,
                    mr.ctc=jsonMr.ctc,
                    mr.note = mJson.jsons.mr.note;
                return [mr];
            },getBg : function(contentObj,ncib){
                var resp = {os: [], rs: [], BI: 'Y'};
                _.each(contentObj, function(type, i){
                    _.each(type, function(content, j){
                        if(content.bg){
                            var bg = content.bg;
                            resp[(i ? 'rs' : 'os')].push({
                                sec:content.fr+'_'+content.to,
                                bg:{
                                    ADT:{cib: (ncib ? '0 KG' : bg.cib), cab:bg.cab}
                                }
                            });
                        }
                    });
                });
                return [resp];
            },
            getCheapestSolution: function(legData){
                try{
                    var tabCache = CT.cache[CT.settings.currentTab];
                    var mapping = legData ? lagdata : CT.masterJson.get().mapping;


                    //if(tabCache.cheapestSplrtSolutions)//to be accomodated..
                    //return tabCache.cheapestSplrtSolutions;

                    if(tabCache.cheapestFlightSolutions)
                        return tabCache.cheapestFlightSolutions;
                    var legs = {};
                    _.each(mapping,function(mapping,i){
                        legs[i] = _.first(_.sortBy(mapping, function(map) {
                            if(map.fare[map.fare.dfd])
                                return map.fare[map.fare.dfd].pr
                        }));
                    });
                    return tabCache.cheapestFlightSolutions = legs;
                }catch(e){
                    window.ct_debug && console.log(e);
                    return null;
                }
            },
            trackFlightMoengageOnSearch : function(eventType, data){
                if(data && window.moengageEnabled){
                    data = _.deserialize(data);
                    var classList = {"Economy" : "e", "Business" : "b", "First" : "f", "Premium+Economy" : "pe"};
                    var tripTypeList = {"OneWay" : "ow", "RoundTrip" : "rt", "MultiCity" : "mc"}
                    var paxCount = parseInt(data.adults) + parseInt(data.childs) + parseInt(data.infants);
                    var currentDate = "";
                    if(window.serverCurrentDate){
                        currentDate = window.serverCurrentDate.getDate() + "/" + parseInt(window.serverCurrentDate.getMonth()+1) + "/" + window.serverCurrentDate.getFullYear();
                    }
                    var trackMoengageObj = {
                        "o"   : data.from ? data.from : "",
                        "d"   : data.to ? data.to : "",
                        "c"   : "",
                        "p"   : (data.intl == "n") ? "d" : "i",
                        "st"  : (data.trip_type && tripTypeList[data.trip_type]) ?  tripTypeList[data.trip_type] : "",
                        "dd"  : (data.depart_date) ? data.depart_date : "",
                        "rd"  : (data.return_date) ? data.return_date : "",
                        "dx"  : (currentDate != "" && data.depart_date) ? CT.utils.diffDates(currentDate, data.depart_date) : "",
                        "los" : "",
                        "pc"  : paxCount,
                        "ac"  : (data.adults) ? data.adults : "",
                        "cc"  : (data.childs) ? data.childs : "",
                        "ic"  : (data.infants) ? data.adults : "",
                        "dl"  : ""
                    }

                    if(data.trip_type == "MultiCity"){
                        var lastReturnDate = "";
                        if(data.from1)trackMoengageObj.o1 = data.from1;
                        if(data.from2)trackMoengageObj.o2 = data.from2;
                        if(data.from3)trackMoengageObj.o3 = data.from3;
                        if(data.from4)trackMoengageObj.o4 = data.from4;
                        if(data.from5)trackMoengageObj.o5 = data.from5;
                        if(data.from6)trackMoengageObj.o6 = data.from6;
                        if(data.to1)trackMoengageObj.d1 = data.to1;
                        if(data.to2)trackMoengageObj.d2 = data.to2;
                        if(data.to3)trackMoengageObj.d3 = data.to3;
                        if(data.to4)trackMoengageObj.d4 = data.to4;
                        if(data.to5)trackMoengageObj.d5 = data.to5;
                        if(data.to6)trackMoengageObj.d6 = data.to6;
                        if(data.depart_date_1){trackMoengageObj.dd1 = data.depart_date_1;}
                        if(data.depart_date_2){trackMoengageObj.dd2 = data.depart_date_2; lastReturnDate = data.depart_date_2 }
                        if(data.depart_date_3){trackMoengageObj.dd3 = data.depart_date_3; lastReturnDate = data.depart_date_3}
                        if(data.depart_date_4){trackMoengageObj.dd4 = data.depart_date_4; lastReturnDate = data.depart_date_4}
                        if(data.depart_date_5){trackMoengageObj.dd5 = data.depart_date_5; lastReturnDate = data.depart_date_5}
                        if(data.depart_date_6){trackMoengageObj.dd6 = data.depart_date_6; lastReturnDate = data.depart_date_6}
                        trackMoengageObj.dx = (currentDate != "" && data.depart_date_1 && CT.utils.diffDates) ? CT.utils.diffDates(currentDate, data.depart_date_1) : "";
                        if(lastReturnDate != "" && CT.utils.diffDates){trackMoengageObj.los = CT.utils.diffDates(data.depart_date_1, lastReturnDate)}
                    }else if(data.return_date && data.depart_date && CT.utils.diffDates){
                        trackMoengageObj.los = CT.utils.diffDates(data.depart_date, data.return_date);
                    }
                    CT.utils.helperFunctions.tpTrack({'tp':'moengage','category':eventType,'values':trackMoengageObj});
                }
            },

			/*Baggage*/
            baggage: {

                getIndex: function(fl){
                    return (fl.fr+'_'+fl.to+'_')+moment(fl.dpd+' '+fl.dp, "DD/MM/YYYY HH:mm").format("YYYY-MM-DD_HH:mm");////fl.fr+'_'+fl.to+'_')+moment(fl.dpd+' '+fl.dp, "DD/MM/YYYY HH:mm").format("YYYY-MM-DD_HH:mm:ss");//(new Date(moment(fl.ad+' '+fl.a, "DD/MM/YYYY HH:mm").format("YYYY-MM-DD HH:mm:ss")).getTime()/1000)
                },
                getInfo: function(opts, callback){
                    try{
                        var solutions = [], tabCache = CT.cache[CT.settings.currentTab];
                        if(opts.isSRP){
                            _.map(opts.solutionIds,function(sId,i){
                                solutions.push(opts.mJson.mapping[i][sId]);
                            });

                        }
                        if(opts.flightDetailsArr)
                            _.each(opts.flightDetailsArr,function(solution){
                                _.each(solution.flArr, function(fl){
                                    fl.index =  CT.utils.helperFunctions.baggage.getIndex(fl);
                                });
                            });
                        opts.solutions  = solutions;
                        var mjson = CT.masterJson.get();
                        
                        var hasLiteFare = false;
                        if (!opts.isSplitScreen) {
                            _.each(opts.solutions,function(solution, count){
                                if (!hasLiteFare) {
                                    hasLiteFare = solution.summary.isLITEFare;
                                }
                            });
                        }
                        if(opts.isSplitScreen){

                            var bgRTHtml = []
                            _.each(opts.solutions,function(solution,count){
                                var fromTo = solution.summary.fullHeader;
                                var bgSegments = [];
                                var showSmallHeader = solution.content.length > 1 ? 1 : 0;
                                var isLiteFare = solution.summary.isLITEFare;
                                _.each(solution.content,function(con){
                                    CT.Mustache.clearCache();
                                    var seg = {}
                                    if(showSmallHeader){
                                        seg.sec = con.fr +' \u2192 '+ con.to;
                                    }
                                    seg.index = CT.utils.helperFunctions.baggage.getIndex(con);
                                    bgSegments.push(seg);
                                });
                                CT.Mustache.clearCache();

                                bgRTHtml.push(CT.to_html('RTBaggageHeaderTpl', {'fromTo': fromTo,newFlow:true,bgSegments: bgSegments, isLiteFare: isLiteFare}));
                            });


                            var offset = opts.$parentLi.offset(), left = offset.left, _top = offset.top
                            if($('.baggagePopover') && $('.baggagePopover').length >0) $('.baggagePopover').remove();
                            $(document.body).append(CT.to_html('FarePopoverTpl', {'cls' : 'baggagePopover'}));
                            $('.baggagePopover')
                                .find('.tipsyInner').html('').append("<div class='row'>"+bgRTHtml.join('')+"</div>").end()
                                .css({'display' : 'block', 'position' : 'absolute', 'z-index' : '200000', 'top' : _top + 13, 'left' : left})
                                .delegate(".close" , "click", function() {
                                    $('.baggagePopover').hide();
                                });
                            var $baggageContainer = $('.baggagePopover');
                        }else
                        if(opts.$parentLi){

                            var baggageHtml = CT.to_html('baggageTmpl', {flightDetailsArr : opts.flightDetailsArr,isMeta:this.isMeta, hasLiteFare: hasLiteFare});
                            var $baggageContainer = opts.$parentLi.find("[eleidentifier='baggage']");
                            $baggageContainer.html(baggageHtml);
                        }
                        if(!tabCache.baggageCache)
                            tabCache.baggageCache = {};

                        if(tabCache.baggageCache[opts.solutionIds.join(',')]){
                            resJson = tabCache.baggageCache[opts.solutionIds.join(',')];
                            CT.utils.helperFunctions.baggage.render(resJson, $baggageContainer, opts,function(){
                                callback(null, resJson);
                            });
                        }else{
                            CT.utils.helperFunctions.baggage.createRequestJson.apply(this,[opts,{solutions:solutions}, function(reqJson){
                                CT.utils.helperFunctions.baggage.sendRequestJson(reqJson,
                                    function(resJson){// success callback
                                        if(mjson && mjson.jsons.searchType.isIntl && mjson.jsons.bbEnabled) {
                                            tabCache.baggageCache = {};
                                        }else{
                                            tabCache.baggageCache[opts.solutionIds.join(',')] = resJson;
                                        }
                                        if(opts.noRender){
                                            callback(null, resJson);
                                        }else
                                            CT.utils.helperFunctions.baggage.render(resJson, $baggageContainer, opts,function(){
                                                callback(null, resJson);
                                            });
                                    },function(){// Error Callback
                                        CT.utils.helperFunctions.baggage.noBaggage($baggageContainer,null, opts);
                                    }

                                );
                            }]);
                        }
                    }catch(e){
                        callback(e);
                    }
                },
                createRequestJson: function(obj,opts, callback){
                    var mjson = CT.masterJson.get();
                    var withCabin = obj.$parentLi.find('#withCabinBaggage input');
                    var withcabChecked  = $(withCabin).is(':checked')? true : false
                    var helper = {
                        selectedFare: function (solution){
                            var otherOptions = {isSPLRT:solution.fare.spl, 'isCorpFare' : false}
                            if(window.productCode == 'CP'){
                                otherOptions.isCorpFare = obj.$parentLi.hasClass('corpFareChosen');
                            }
                            if(mjson && mjson.jsons.searchType.isIntl && solution.fare && solution.fare.HBAG && !withcabChecked){
                                return CT.utils.helperFunctions.getFlightFare(solution.fare.HBAG, null, otherOptions);
                            }else{
                                return CT.utils.helperFunctions.getFlightFare(solution.fare, null, otherOptions);
                            }
                        }
                    };

                    var scClean = this.tabCache.searchParams.clean;
                    var scType = this.tabCache.searchType;
                    var sid = this.tabCache.sid

                    var reqJson = {sol: [], sc: searchCriteria()};
                    isSplitScreen = ((!this.isIntl) && (this.isRT || this.isMultiCity) || this.intlSpecialRT);

                    function flight(solution, mappingNumber){
                        return { seg: segment(solution, mappingNumber)};
                    }
                    function segment(solution, mappingNumber){
                        var priceObj = helper.selectedFare(solution),baseClass = [];


                        if(priceObj.bc){
                            baseClass.push(priceObj.bc.split(","));
                        }
                        baseClass = _.flatten(baseClass);
                        var baseClassAirline = {};



                        return _.map(solution.content,function(con, i){
                            var alCode = con.al+'-'+con.alNum;
                            if(!baseClassAirline[alCode]) //For stop over flights
                                baseClassAirline[alCode] = baseClass[segCount++];

                            return {
                                "dep": con.fr,
                                "arr": con.to,
                                "dd": moment(con.dpd+' '+con.dp, "DD/MM/YYYY HH:mm").format("YYYY-MM-DD HH:mm"),//,//"17-03-2017-00:00:00",
                                "ad": moment(con.ad+' '+con.a, "DD/MM/YYYY HH:mm").format("YYYY-MM-DD HH:mm"),//"20-10-2000-00:00:00",
                                "fn": con.alNum,
                                "al": con.al,
                                "oa": con.oa || '',
                                "bc": baseClassAirline[alCode] || '' //For Stopover flight
                            }
                        });
                    }
                    function fare(solution){
                        var priceObj = helper.selectedFare(solution);
                        return {
                            "mi": priceObj.mi ? true : false,
                            "fk": priceObj.fk,
                            "ncib": priceObj.ncib,
                            "ctype": solution.content[0].ct
                        }
                    }


                    function searchCriteria(){
                        var stypeJson = {
                            'AG' : 'AGENCY',
                            'CP' : 'CORP',
                            'undefined' : 'B2B'
                        }
                        return {
                            "intl": scType.isIntl,
                            "mcity": scType.isMultiCity,
                            "adt": scClean.adults,
                            "chd": scClean.childs,
                            "inf": scClean.infants,
                            "scr": scType.sellCurr,
                            "sid": window.sid,
                            "sct": scType.sellingCountry,
                            "stype": window.product=='B2B' ? stypeJson[window.productCode] : "B2C"
                        }
                    }
                    var segCount = 0;
                    _.each(opts.solutions, function(sol,mappingNumber){

                        if(isSplitScreen){
                            segCount = 0;
                            reqJson.sol.push( { fl: [flight(sol, mappingNumber)], fre : fare(sol) } );
                        }else{
                            if(!reqJson.sol[0])
                                reqJson.sol[0] = { fl: [], fre: fare(sol) };
                            reqJson.sol[0].fl.push( flight(sol, mappingNumber) );
                        }
                    });
                    callback(reqJson);
                },
                sendRequestJson: function(data, successCallback, errorCallback){
                    clearTimeout(this.baggageTimer);
                    this.baggageTimer = setTimeout(function(){
                        $.ajax({
                            url: (CT.settings.localhost?'http://l.cleartrip.com:8080':'') +  '/flights/freeBaggageInfo',
                            data: JSON.stringify(data),
                            type:'post',
                            contentType: 'application/json; charset=utf-8',
                            dataType: 'json'
                        }).then(successCallback).fail(errorCallback)
                    },200);

                },
                render: function(respJson, $baggageContainer,opts, callback){
                    var that = this;
                    var detailTmpl = 'baggageDetails';

                    if(opts.isSplitScreen){
                        detailTmpl = 'RTBaggageTpl';
                    }

                    if(respJson && respJson.BI && !$.isEmptyObject(respJson.BI)){

                        if(opts.isSplitScreen)
                            $baggageContainer.find('.rtBaggageLoader').addClass('hide');

                        $baggageContainer.find('.baggageSummary').each(function(){
                            var $this = $(this).removeClass('hide');
                            var index = $this.data('index');
                            var sector = respJson.BI[index];
                            if(sector && !$.isEmptyObject(respJson.BI[index]) && respJson.BI[index].bg && respJson.BI[index].bg.ADT){
                                sector.newFlow = true;
                                var baggageDetailsHtml  = CT.to_html(detailTmpl, sector);
                                if(opts.isSplitScreen)
                                    $this.find('dd').html(baggageDetailsHtml);
                                else
                                    {
                                        baggageDetailsHtml.match(/([A-Z]{2,} )+[A-Z]{2,}/) && baggageDetailsHtml.match(/([A-Z]{2,} )+[A-Z]{2,}/g).map(
                                            function(match,ind){
                                                baggageDetailsHtml=baggageDetailsHtml.replace(match,(ind?'<br>':'')+'<b>'+match+'</b>')
                                                }
                                            )
                                        $this.find('.baggageDetails li').html(baggageDetailsHtml);
                                    }
                            }else that.noBaggage($baggageContainer, $this, opts);
                        });
                        if(respJson.bgNote){
                            $baggageContainer.find('.baggageValue[errorinfo=piecesInfo]').html(respJson.bgNote);
                        }

                    }else this.noBaggage($baggageContainer,null, opts);

                },
                noBaggage : function ($baggageContainer,$elem, opts) {
                    if(opts.isSplitScreen)
                        $baggageContainer.find('.rtBaggageLoader').addClass('hide');

                    if($elem){
                        if(opts.isSplitScreen)
                            $elem.addClass("fadedSummary").removeClass('hide').find('dd').html('<small>'+CT.messages.air.NoBaggageMsg+'</small>');
                        else
                            $elem.addClass("fadedSummary").find('.baggageDetails li').html(CT.messages.air.NoBaggageMsg);
                    }else{//all
                        if(opts.isSplitScreen){
                            $baggageContainer.find('.baggageSummary').addClass("fadedSummary").removeClass('hide').find('dd').html('<small>'+CT.messages.air.NoBaggageMsg+'</small>');
                        }else{
                            $baggageContainer.find('.baggageDetails li').html(CT.messages.air.NoBaggageMsg);
                            $baggageContainer.find('ul').addClass("fadedSummary");
                        }
                    }
                },
            }


			/*Baggage*/

        }, // END of helper functions namespace


        getNumLegs : function(paramsHash){
            var numLegs  = 0;

            _.times(5, function(n){
                if(paramsHash["from"+(n+1)]){
                    numLegs ++;
                }
            });
            return numLegs;
        },


        modifySearch:{

            "open":function($arrow,$link){
            	$(".searchCheckBox").hide();
            	if(!CT.cache.els)
            		return;

                if(!CT.cache.els["$resultContainer"+ CT.settings.currentTab]){
                    CT.cache.els["$resultContainer"+ CT.settings.currentTab] = $("#ResultContainer_"+CT.settings.currentTab);
                }


                var $homeCenter = CT.cache.els.$homeCenter,
                    $resultContainer = CT.cache.els["$resultContainer"+ CT.settings.currentTab],
                    $homeSection = CT.cache.els.$homeSection,
                    $resultSection = CT.cache.els.$resultSection;

                if(!$arrow){
                    $arrow = $resultContainer.find("#modifySearchLink").find("i");
                }
                if(!$link){
                    $link = $arrow.parent();
                }

                $link.parent().addClass("current");
                $arrow.removeClass("rArrow").addClass("dArrow white");
                $homeSection.show();

                $homeSection.addClass("modifySearch");
                $resultSection.addClass("modifySearch");

                if($homeCenter.css("min-height")){
                    $homeCenter.attr("backup-min-height",$homeCenter.css("min-height")).css("min-height","");
                }

                $homeCenter.css("height",$homeCenter.height());
                setTimeout(function(){
                    $homeCenter.css("-webkit-transition","none");
                    setTimeout(function(){
                        $homeCenter.css("height","");
                        setTimeout(function(){
                            $homeCenter.css("-webkit-transition","");
                        },100);
                    },100);
                },500);
                $('.flexiCalander').addClass("hide");

                var mJson = CT.masterJson.get();
                var searchType = CT.cache[CT.settings.currentTab] && CT.cache[CT.settings.currentTab].searchType;
                var hasMatrixCalendar = mJson && mJson.jsons.fse_cal;

                $resultContainer.find("div.miniCalendar").addClass("mediumCalendar").removeClass("hide miniCalendar");
                
                CT.fire('showMediumCalendar');
                
                if( searchType && searchType.roundTrip && window.location.pathname.indexOf("results") >=0 && hasMatrixCalendar){
                    $resultContainer.find("div.mediumCalendar").addClass("hide");
                    $('.flexiCalander').removeClass("hide");
                }

                $resultContainer.find(".primaryBar .center").fadeOut("fast",function(){
                    $resultContainer.find(".primaryBar .center").css("visibility","hidden").show();
                });
                $('.tipsyW').remove();

                CT.fire('hideRecentNearbyWidget');
            },

            "close":function($arrow,$link){
            	if(!CT.cache.els)
            		return;

                if(!CT.cache.els["$resultContainer"+ CT.settings.currentTab]){
                    CT.cache.els["$resultContainer"+ CT.settings.currentTab] = $("#ResultContainer_"+CT.settings.currentTab);
                }


                var $homeCenter = CT.cache.els.$homeCenter,
                    $resultContainer = CT.cache.els["$resultContainer"+ CT.settings.currentTab],
                    $homeSection = CT.cache.els.$homeSection,
                    $resultSection = CT.cache.els.$resultSection;

                if(!$arrow){
                    $arrow = $resultContainer.find("#modifySearchLink").find("i");
                }
                if(!$link){
                    $link = $arrow.parent();
                }

                $link.parent().removeClass("current");
                $arrow.removeClass("dArrow white").addClass("rArrow");

                $homeSection.hide();

                $homeSection.removeClass("modifySearch");
                $resultSection.removeClass("modifySearch");

                if($homeCenter.attr("backup-min-height")){
                    $homeCenter.css("min-height",$homeCenter.attr("backup-min-height")).removeAttr("backup-min-height");
                }

                $resultContainer.find("div.mediumCalendar").addClass("miniCalendar").removeClass("mediumCalendar");
                $resultContainer.find(".primaryBar .center").css("visibility","visible").hide().fadeIn("fast");

                var searchType = CT.cache[CT.settings.currentTab] && CT.cache[CT.settings.currentTab].searchType;
                var mJson = CT.masterJson.get();
                var config = mJson && mJson.jsons.fse_cal;

                if( searchType && searchType.roundTrip && window.location.pathname.indexOf("results") >=0 && config){
                    $resultContainer.find("div.miniCalendar").removeClass("hide");
                    $('.flexiCalander').addClass("hide");
                }
                CT.fire('hideMiniCalendar');
                CT.fire('showMiniCalendar',[true]);
                CT.fire('showRecentNearbyWidget');
            },


            openLabel:function(data){

                var displayData = {};
                var $ctCenter = $("#GlobalNav .ctCenter");
                displayData.cityInfo = [];

                if(CT.settings.currentTab == $ctCenter.find(".searchSummary").data("sc")){
                    return;
                }

                if(data.from1){ // for multicity

                    var citiesArray = [];
                    var legs = Number(data.num_legs);

                    _.times(legs,function(n){
                        n = n+1;
                        if(data["origin"+n] && data["destination"+n]){
                            citiesArray.push( [ (data["origin"+n] && data["origin"+n].split(",")[0] || data["from"+n]) , (data["destination"+n] && data["destination"+n].split(",")[0] || data["to"+n]) ]);
                        }
                    });

                    for(var currentCityIndex = 0; currentCityIndex < citiesArray.length; currentCityIndex ++){ //loop to form  the multicity city string

                        var current_cities, current_cities_to;
                        var next_cities, next_cities_from, next_cities_to;

                        if(citiesArray[currentCityIndex]){
                            current_cities = citiesArray[currentCityIndex];
                            current_cities_to = current_cities[current_cities.length-1];


                            for(var nextCityIndex = currentCityIndex+1; nextCityIndex < citiesArray.length; nextCityIndex ++){

                                if(citiesArray[nextCityIndex]){
                                    next_cities = citiesArray[nextCityIndex];
                                    next_cities_from = next_cities[0];
                                    next_cities_to = next_cities[next_cities.length-1];

                                    if(current_cities_to == next_cities_from){
                                        current_cities.push(next_cities_to)
                                        citiesArray[nextCityIndex] = null;
                                        current_cities_to = current_cities[current_cities.length-1];
                                    }
                                }
                            }
                        }
                    }

                    citiesArray = _.filter(citiesArray,function(cities){ // clean up cities Array
                        return (cities)?true:false;
                    });
                    _.each(citiesArray,function(cities,index){ // form cityInfo element from cities Array
                        displayData.cityInfo.push({isMC:true, hasNextCity:(index == citiesArray.length-1)?false:true, city:cities.join(" \u2192 ")})
                    });

                    //formated city string
                    //{{city}}{{#hasNextCity}}, {{/hasNextCity}}
                    displayData.formatedCities = "";
                    _.each(displayData.cityInfo,function(cI){
                        displayData.formatedCities += cI.city + ((cI.hasNextCity)?", ":"");
                    });

                    //for dates
                    displayData.depart_date = moment(data.depart_date_1, "DD/MM/YYYY").format('ddd, DD MMM');
                    displayData.last_depart_date = moment(data["depart_date_" + data.num_legs], "DD/MM/YYYY").format('ddd, DD MMM');
                }else{
                    //for cities
                    if(data.from){
                        displayData.cityInfo.push({city: data.origin && data.origin.split(",")[0] || data.from})
                    }
                    if(data.to){
                        var returnSymb = " \u21C4 ";
                        if($.browser.msie && parseInt($.browser.version, 10) < 9) {
                            returnSymb = " - ";
                        }
                        displayData.cityInfo.push({city:data.destination && data.destination.split(",")[0] || data.to,  rtSymbol:(data.return_date)?returnSymb:false ,  owSymbol:(data.return_date)?false:" \u2192 "})
                    }

                    //formated city string:
                    //{{#rtSymbol}} {{rtSymbol}} {{/rtSymbol}}{{#owSymbol}} {{owSymbol}} {{/owSymbol}}{{city}}
                    displayData.formatedCities = "";
                    _.each(displayData.cityInfo,function(cI){
                        displayData.formatedCities += ((cI.rtSymbol)?cI.rtSymbol:"") + ((cI.owSymbol)?cI.owSymbol:"") + cI.city;
                    });

                    //for dates
                    displayData.depart_date = moment(data.depart_date, "DD/MM/YYYY").format('ddd, DD MMM');
                    if(data.return_date){
                        displayData.return_date = moment(data.return_date, "DD/MM/YYYY").format('ddd, DD MMM');
                    }
                }

                // for pax info
                displayData.adults = data.adults;
                if(parseInt(data.adults,10) > 1)
                    displayData.mA = true;
                else
                    displayData.mA = false;

                if(data.childs && parseInt(data.childs,10)){
                    displayData.childs = data.childs;
                    if(parseInt(data.childs,10) > 1)
                        displayData.mC = true;
                    else
                        displayData.mc = false;
                }

                if(data.infants && parseInt(data.infants,10)){
                    displayData.infants = data.infants;
                    if(parseInt(data.infants,10) > 1)
                        displayData.mI = true;
                    else
                        displayData.mI = false;
                }

                // alter DOM

                $ctCenter.find(".feedbackLink").hide();
                if($ctCenter.find(".searchSummary").length == 0){
                    $ctCenter.append("<div class='searchSummary'></div>");
                }

                $ctCenter.find(".searchSummary").show().html(CT.to_html('SearchHeaderTemplate',displayData));
                $ctCenter.find(".searchSummary").data("sc",CT.settings.currentTab);

                $("body").scrollTop(0);
            },
            closeLabel:function(){
                var $ctCenter = $("#GlobalNav .ctCenter");
                $ctCenter.find(".feedbackLink").show();
                $ctCenter.find(".searchSummary").hide();
            }
        },

        UILogger: (function(){

            var from = ["0","","-1"], to = ["0","","-1"], d1 = "0", d2 = "0", url, fe = [], t, src = "h";
            var fromUp  = [], toUp = [];
            var interval = false;
            var intervalTime = 6000;
            var allIntervals = [];

            url = window.location.href;

            ac = CT.utils.cookies.read('Apache');

            var snapshots = [];

            function setAndGetInterval(){


                intervalTime *= 3
                return intervalTime;


            }

            function UIForm(){

                this.from = $("#FromTag").val() ? ["1", $("#FromTag").val(), "-1"] : from;
                this.to = $("#ToTag").val() ? ["1", $("#ToTag").val(), "-1"] : to;
                this.d1 = $("#DepartDate").val() ? "1" : "0" ;
                this.d2 = $("#ToDate").val() ? "1" : "0";
                this.trip_type = $(".tripType input:checked").val();

            }

			/*
			 UIForm.isComplete = function(){

			 if(this.trip_type === "OneWay")
			 {
			 if($("#FromTag").val() && $("#ToTag").val() && $("#DepartDate").val())
			 {
			 return true;
			 }
			 }
			 else if(this.trip_type === "RoundTrip")
			 {
			 if($("#FromTag").val() && $("#ToTag").val() && $("#DepartDate").val())
			 {
			 return true;
			 }
			 }


			 } */


            $("#FromTag").keypress(function(){

                fromUp = [];
                fromUp.push("1");
                fromUp.push($("#FromTag").val());
                if(t){
                    fromUp.push(String(t));
                }
                else
                {
                    fromUp.push("-1");
                }
                //checkForErrors();

            });


            $("#ToTag").keypress(function(){

                toUp = [];
                toUp.push("1");
                toUp.push($("#ToTag").val());
                if(t){
                    toUp.push(String(t));
                }
                else
                {
                    toUp.push("-1");
                }
                //checkForErrors();

            });

            $("#From").change(function(){

                logToServer();

            });

            $("#To").change(function(){

                logToServer();

            });

            $("#FromDate").change(function(){

                uiform.d1 = "1";
                //checkForErrors();
                logToServer();

            });

            $("#ToDate").change(function(){

                uiform.d2 = "1";
                //checkForErrors();
                logToServer();

            });

            $("#SearchBtn").click(function(){

                src = "h";
                //interval = true;
                //clearAllIntervals();
                //logToServer();

            });


            $("#ModSearchBtn").click(function(){

                src = "m";
            });

            $(document).ready(function(){

                //uiform = new UIForm();

                logToServer();

            });


            function clearAllIntervals(){

                for(var i=0, len = allIntervals.length; i < len; i++)
                {
                    clearInterval(allIntervals[i]);
                }

            }


            function setURL(u){

                url = u;
            }

            function setFormErrors(err){
                fv = "1";
                fe = makeErrorArray(err);
                //clearAllIntervals();
                logToServer();


            }

            function makeErrorArray(err){

                arr = [];

                _.each(err, function(ele, i, list){

                    arr.push(ele['mess']+" "+ele['name']);

                });



                return arr;
            }

            function setTime(time){
                t = time;
            }

            function makeJSON(){

                uiform = new UIForm();

                var logObj = {};

                logObj.from = fromUp.length ? fromUp : uiform.from;

                logObj.to = toUp.length ? toUp : uiform.to;
                logObj.d1 = uiform.d1 ? uiform.d1 : "0";
                logObj.d2 = uiform.d2 ? uiform.d2 : "0";
                logObj.src = src;


                logObj.url = url =  window.location.href;
                logObj.fe = fe;
                logObj.fv = "0";
                if(fe.length){
                    logObj.fv = "1";
                }


                return logObj;

            }

            function checkForErrors(){

                if(fe.length && interval){

                    fe = [];
                    interval = false;

                }

            }

            //this function need to excute for air srp
            if(CT.app === "air") {
				/*CT.subscribe('results', function(){

				 fe = [];
				 logToServer();

				 });*/
            }

            function getUserAgent(){
                var browser;
                if($.browser.webkit)
                    browser =  "webkit";

                if($.browser.opera)
                    browser = "opera";

                if($.browser.msie)
                    browser = "msie";

                if($.browser.mozilla)
                    browser =  "mozilla";

                if(!browser)
                {
                    browser = "other";
                }

                return browser + " "+ $.browser.version;
            }



            function logToServer(){
                // logging removed as it no longer being used.
				/*
				 var logObj = makeJSON();
				 snapshots.push(logObj);
				 logObj.ac = ac;
				 logObj.t = String( new Date().getTime() - 1367519400000 );
				 logObj.b = getUserAgent();
				 $.ajax({ type: "POST", url : '/lui', data: JSON.stringify(logObj),
				 global : false,
				 contentType : "application/json",
				 success: function(){ },
				 complete: function(){ }

				 }).done(function(){
				 }).fail(function(){
				 });

				 */
            }


            return {

                setFormErrors : setFormErrors,
                setTime : setTime,
                makeJSON : makeJSON,
                setURL : setURL,
                logToServer : logToServer

            }



        })()

    });
})
;
